<div *commonUiOptionalWizardStep id="steuerlicheBeratungAngaben">
    <div class="mb-5x pt-1">
        <div class="d-flex justify-content-between mb-1x">
            <h2>{{ 'COMMON_UI.FRAGEBOGEN.STEUERLICHEBERATUNG.TITEL' | translate }}</h2>
            <common-ui-daten-uebernahme (picked)="onBeraterPicked($event)"
                                        [itemTemplate]="datenuebernahmeSteuerberatung"
                                        [items]="stammdaten?.berater" [readonly]="readonly"
                                        context="Steuerberatung"></common-ui-daten-uebernahme>
        </div>

        <div *ngIf="requiredEmptySteuerberater" class="col-sm-12 p-0">
            <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.EMPFANGSBEVOLLMAECHTIGUNG.LEER_STEUERBERATER' | translate"
                            type="danger"></common-ui-card>
        </div>

        <div class="col-sm-12 col-lg-12 p-0 mb-3x">
            <common-ui-card [message]=" 'COMMON_UI.FRAGEBOGEN.STEUERLICHEBERATUNG.INFO' | translate"
                            type="info">
            </common-ui-card>
        </div>

        <div class="mb-3x">
            <common-ui-person-typ
                    [(data)]="data"
                    [readonly]="readonly"
                    [requiredSteuerberater]="requiredSteuerberater"
                    (dataChange)="clearSteuerlicheBeratung(data.personenTyp)">
            </common-ui-person-typ>
        </div>

        <common-ui-personenstamm-daten *ngIf="data.personenTyp === personenTypEnum.NatPers"
                                       [(data)]="data.natuerlichePerson" [readonly]="readonly">
        </common-ui-personenstamm-daten>

        <common-ui-juristische-person *ngIf="data.personenTyp === personenTypEnum.NNatPers"
                                      [(data)]="data.juristischePerson" [readonly]="readonly">
        </common-ui-juristische-person>
    </div>

    <div *ngIf="data.personenTyp">
        <div class="mb-5x">
            <h2 class="mb-3x">{{ 'COMMON_UI.ADRESSEN.TITEL' | translate }}</h2>
            <common-ui-adresserfassung
                    [(auslandsadresse)]="data.auslandsadresse"
                    [(inlandsadresse)]="data.inlandsadresse"
                    [(postfachadresse)]="data.postfachadresse"
                    [readonly]="readonly"
                    [stammdatenAuslandsAdresse]="stammdaten?.berater?.auslandsadressen?.array"
                    [stammdatenInlandsadresse]="stammdaten?.berater?.inlandsadressen?.array"
                    [stammdatenPostfachadresse]="stammdaten?.berater?.postfachadressen?.array">
            </common-ui-adresserfassung>
        </div>

        <div class="mb-5x">
            <h2
                    class="mb-3x">{{ 'COMMON_UI.KOMMUNIKATIONSMITTEL.TITEL' | translate }}
            </h2>
            <common-ui-kommunikationsmittel [(data)]="data.kommunikationsmittel" [readonly]="readonly"
                                            [stammdatenTelefonnummern]="stammdaten?.berater?.kommunikation?.telefonnummern?.array"
                                            disableInternet="true"
                                            maxTelefonnummern="2"></common-ui-kommunikationsmittel>
        </div>
    </div>
</div>

<ng-template #datenuebernahmeSteuerberatung let-item="item">
    <h4 *ngIf="item?.personenTyp === 'NatPers'"
        class="list-group-item-heading">
        {{item?.natuerlichePerson?.titel}}
        {{item?.natuerlichePerson?.vorname}}
        {{item?.natuerlichePerson?.namensvorsatz}}
        {{item?.natuerlichePerson?.namenszusatz}}
        {{item?.natuerlichePerson?.nachname}}
    </h4>
    <h4 *ngIf="item?.personenTyp === 'NNatPers'"
        class="list-group-item-heading">{{item?.juristischePerson?.firmenname}}
    </h4>
</ng-template>
